export default [
    {
        path: '/meals',
        name: 'Meal_List',
        component: () => import('@/views/reservation/meal/list.vue'),
        meta: {
            authRequired: true,
            permission: 'meals.index'
        }
    },
    {
        path: '/meals/create',
        name: 'Meal_Create',
        component: () => import('@/views/reservation/meal/create.vue'),
        meta: {
            authRequired: true,
            permission: 'meals.store'
        }
    },
    {
        path: '/meals/:id/edit',
        name: 'Meal_Edit',
        component: () => import('@/views/reservation/meal/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'meals.show',
            navActiveLink:'Meal_List'
        }
    },
]
